import {
  genericCocktailMatchSchema,
  venuePreferencesSchema,
  type GenericCocktailMatch,
  type VenuePreferences,
} from "@vibetail/contracts";

const SHARE_PARAM = "match";

export function genericMatchSharePath(result: GenericCocktailMatch, preferences: VenuePreferences): string {
  const payload = JSON.stringify({ result, preferences });
  const bytes = new TextEncoder().encode(payload);
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  const encoded = btoa(binary).replaceAll("+", "-").replaceAll("/", "_").replace(/=+$/, "");
  return `/match?${SHARE_PARAM}=${encoded}`;
}

export function readGenericMatchShare(search: string): {
  result: GenericCocktailMatch;
  preferences: VenuePreferences;
} | undefined {
  const value = new URLSearchParams(search).get(SHARE_PARAM);
  if (!value) return undefined;
  try {
    const binary = atob(value.replaceAll("-", "+").replaceAll("_", "/"));
    const bytes = Uint8Array.from(binary, (character) => character.charCodeAt(0));
    const parsed: unknown = JSON.parse(new TextDecoder().decode(bytes));
    if (!isRecord(parsed)) return undefined;
    const result = genericCocktailMatchSchema.safeParse(parsed.result);
    const preferences = venuePreferencesSchema.safeParse(parsed.preferences);
    return result.success && preferences.success
      ? { result: result.data, preferences: preferences.data }
      : undefined;
  } catch {
    return undefined;
  }
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
